export var mapping = {
  "booking-timer": function bookingTimer() {
    return import("./src/components/desktop/booking-timer/booking-timer");
  }
};